export enum TabType {
  OVERVIEW = 'OVERVIEW',
  SEED_PORTFOLIO = 'SEED_PORTFOLIO',
  WHY_SFPE = 'WHY_SFPE',
  CALCULATOR = 'CALCULATOR',
  INVESTMENTSTRUCTURE = 'INVESTMENT_STRUCTURE',
  KEYTERMS = 'KEY_TERMS',
  EDOCUMENTS = 'E_DOCUMENTS',
  LEGALS = 'LEGALS',
}
